import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: null,
        reseller: null,
        resellerLogo: null,
        canUseExistingQuote: true,
        canOrderHardware: true,
        canOrderSwitchboards: true,
        canBeUndecided: true,
        includeMarketing: true,
        rtTicket: null,
        hasQuoteHardware: false,
    },
    mutations: {
        /**
         * This will set variables related to reseller flow
         * 
         * @param Object state
         * @param Object value
         */
        setResellerOptions: function(state, value){
            for(const property in value){
                if(state.hasOwnProperty(property)){
                    state[property] = value[property];
                }
            }
        },

        /**
         * Set the token used in the application
         * @param Object state
         * @param string value
         */
        setToken: function(state, value){
            state.token = value;
        },

        /**
         * RT number generated for undecided clients
         * @param Object state
         * @param Object value
         */
        setRtTicketNumber: function(state, value){
            state.rtTicket = value;
        },
    },
    actions: {},
    modules: {}
});
